
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M4 4v10h2v-4h2l5.41 5.41L9.83 19l1.41 1.41 3.59-3.58 3.58 3.58L19.82 19l-3.58-3.59 3.58-3.58-1.41-1.42L14.83 14l-4-4H11a3 3 0 003-3 3 3 0 00-3-3H4m2 2h5a1 1 0 011 1 1 1 0 01-1 1H6V6z"}})])
          )
        }
      }
    